import(/* webpackMode: "eager", webpackExports: ["Courses"] */ "/app/apps/PublicUI/app/(embeds)/embed/list/[list_param]/Courses/index.tsx");
